import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

var vuex = new Vuex.Store({
  state: {
    uploadSteps: ['ProjectForm', 'ExperimentForm', 'DataForm'],

    currentStep: 'ProjectForm',

    currentStepCompleted: false,

    uploadProjectId: null,

    uploadExperimentId: null
  },

  actions: {
  },

  mutations: {
    nextUploadStep (state) {
      var i = state.uploadSteps.indexOf(state.currentStep)
      if (i < state.uploadSteps.length - 1) {
        state.currentStep = state.uploadSteps[i + 1]
      }
    },

    previousUploadStep (state) {
      var i = state.uploadSteps.indexOf(state.currentStep)
      if (i > 0) {
        state.currentStep = state.uploadSteps[i - 1]
      }
    },

    completeStep (state) {
      state.currentStepCompleted = true
    },

    uncompleteStep (state) {
      state.currentStepCompleted = false
    },

    setUploadProjectId (state, id) {
      state.uploadProjectId = id
    },

    setUploadExperimentId (state, id) {
      state.uploadExperimentId = id
    }
  }
})

export default vuex
